import { render, staticRenderFns } from "./AnimatedChekmark.vue?vue&type=template&id=71454522&scoped=true&"
import script from "./AnimatedChekmark.vue?vue&type=script&lang=js&"
export * from "./AnimatedChekmark.vue?vue&type=script&lang=js&"
import style0 from "./AnimatedChekmark.vue?vue&type=style&index=0&id=71454522&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71454522",
  null
  
)

export default component.exports